"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useApplyQueryDelta_1 = require("./hooks/useApplyQueryDelta");
const QueryBuilderContext_1 = require("./QueryBuilderContext");
const QueryDataSource = ({ onUpdating, onUpdateError, onUpdated, onUpdatedQueryName, children }) => {
    var _a;
    const [isQueued, setIsQueued] = (0, react_1.useState)(false);
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    // const [validationError, setValidationError] = useState<QueryValidation>({});
    // const trackChangesRef = useRef(trackChanges);
    // trackChangesRef.current = trackChanges;
    const timeoutRef = (0, react_1.useRef)();
    const onUpdatingRef = (0, react_1.useRef)(onUpdating);
    onUpdatingRef.current = onUpdating;
    const onUpdateErrorRef = (0, react_1.useRef)(onUpdateError);
    onUpdateErrorRef.current = onUpdateError;
    const onUpdatedRef = (0, react_1.useRef)(onUpdated);
    onUpdatedRef.current = onUpdated;
    const onUpdatedQueryNameRef = (0, react_1.useRef)(onUpdatedQueryName);
    onUpdatedQueryNameRef.current = onUpdatedQueryName;
    const queryNameRef = (0, react_1.useRef)(queryManager.query.name);
    /**
     * Validate the Entity Schema
     */
    const validateSchema = (0, react_1.useCallback)((query) => {
        return true;
    }, []);
    // useApplyQueryDelta for applying query changes
    const { updatedResult, isUpdating, updateError, applyQueryDeltas } = (0, useApplyQueryDelta_1.useApplyQueryDelta)(((_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.id) || '');
    // check for query update errors
    (0, react_1.useEffect)(() => {
        if (updatedResult || updateError) {
            setIsQueued(false);
        }
        if (updateError) {
            // undo commit if error
            queryManager.uncommit();
        }
    }, [updateError, updatedResult, queryManager]);
    // Check for query changes, debounce, and save to backend API
    (0, react_1.useEffect)(() => {
        const handleChange = () => {
            var _a;
            if (queryManager.history.uncommitted.length > 0 && validateSchema()) {
                // don't save if no id exists
                if (queryManager.query.id) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = setTimeout(() => {
                        const deltas = queryManager.commit();
                        applyQueryDeltas(deltas);
                    }, 500);
                    setIsQueued(true);
                    (_a = onUpdatingRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdatingRef, queryManager.query);
                }
            }
        };
        queryNameRef.current = queryManager.query.name;
        queryManager.subscribe('change', handleChange);
        return () => {
            queryManager.unsubscribe('change', handleChange);
        };
    }, [queryManager, applyQueryDeltas, validateSchema]);
    // bubble up errors
    (0, react_1.useEffect)(() => {
        var _a;
        if (updateError) {
            (_a = onUpdateErrorRef === null || onUpdateErrorRef === void 0 ? void 0 : onUpdateErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateErrorRef, updateError);
        }
    }, [updateError]);
    // bubble up completd updated query
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (updatedResult) {
            (_a = onUpdatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdatedRef, queryManager.query);
            if (queryManager.query.name &&
                queryManager.query.name !== queryNameRef.current) {
                // notify updated query name only when name changes
                queryNameRef.current = queryManager.query.name;
                (_b = onUpdatedQueryNameRef.current) === null || _b === void 0 ? void 0 : _b.call(onUpdatedQueryNameRef, queryManager.query.name);
            }
        }
    }, [updatedResult, queryManager]);
    return (react_1.default.createElement(react_1.default.Fragment, null, typeof children === 'function'
        ? children({
            isQueued,
            isUpdating,
            queryManager,
            updatedResult,
            updateError
        })
        : children));
};
exports.default = QueryDataSource;
//# sourceMappingURL=QueryDataSource.js.map